import { render, staticRenderFns } from "./QuestionTopicErrorEdit.vue?vue&type=template&id=3ddaae9c&scoped=true&"
import script from "./QuestionTopicErrorEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionTopicErrorEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTopicErrorEdit.vue?vue&type=style&index=0&id=3ddaae9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddaae9c",
  null
  
)

export default component.exports